import { Flex } from 'components';
import styled from 'styled-components';

const ColorBlock = styled(Flex)<{ $background: string }>`
  min-width: 36px;
  height: 36px;
  padding: 0 6px;
  border-radius: 10px;
  background: ${({ $background }) => $background};
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 12px;
  color: #ffffff;
  border: 1px solid ${({ theme }) => theme.palette.neutral.lightGrey};
  flex-shrink: 0;
`;

interface Props {
  codeId?: string;
  colorCode?: string;
}

export const AuditFormCodeBlock: React.FC<Props> = ({
  codeId = '',
  colorCode = ''
}) => (
  <ColorBlock $background={colorCode || '#cccccc'}>
    {codeId.slice(0, 3)}
  </ColorBlock>
);
